<template>
  <div>
    <v-container>
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card flat>
            <v-card-text class="pt-0">
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <h2 class="compeatfont">All Users</h2>
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="py-0">
              <v-tabs
                height="60px"
                rounded
                v-model="tab"
                background-color="primary"
                dark
              >
                <v-tab
                  v-if="this.$store.state.user.userType == 'SA'"
                  :key="0"
                  class="px-5"
                >
                  Super Admin Users ({{ superAdminUsers.length }})
                </v-tab>
                <v-tab :key="1" class="px-5">
                  Admin Users ({{ agencyUsers.length }})
                </v-tab>
                <v-tab :key="2" class="px-5">
                  Agency Sales Users ({{ agencySalesUsers.length }})
                </v-tab>
                <v-tab :key="3" class="px-5">
                  Subscribers - ({{ subscriberUsers.length }})
                </v-tab>
                <v-tab :key="4" class="px-5">
                  Inactive Users - ({{ inactiveUsers.length }})
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  :key="0"
                  v-if="this.$store.state.user.userType == 'SA'"
                >
                  <v-card v-if="!overlay" flat class="py-3 px-3">
                    <v-card-title class="pt-0">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search Clients"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <newUser
                        @successAlert="successAlert"
                        :agencies="allAgencies"
                      />
                    </v-card-title>
                    <!-- {{ activeAcencies }} -->
                    <v-data-table
                      :headers="headers"
                      :items="superAdminUsers"
                      :search="search"
                      :items-per-page="10"
                      :loading="overlay"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.isActive`]="{ item }">
                        <v-chip class="ma-2" color="success"> Active </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in items"
                              :key="index"
                            >
                              <v-list-item-title>{{
                                item.title
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-skeleton-loader
                    v-else
                    height="372px"
                    class="mx-auto"
                    type="table-heading, table-thead, table-tbody, table-tfoot"
                  >
                  </v-skeleton-loader>
                </v-tab-item>
                <v-tab-item :key="1">
                  <v-card v-if="!overlay" flat class="py-3 px-3">
                    <v-card-title class="pt-0">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search Clients"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <newUser
                        @successAlert="successAlert"
                        :agencies="allAgencies"
                      />
                    </v-card-title>
                    <!-- {{ activeAcencies }} -->
                    <v-data-table
                      :headers="headers"
                      :items="agencyUsers"
                      :search="search"
                      :items-per-page="10"
                      :loading="overlay"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.isActive`]="{ item }">
                        <v-chip class="ma-2" color="success"> Active </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="viewUser(item)">
                              <v-list-item-content>
                                <v-list-item-title>
                                  View User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Deactivate User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-skeleton-loader
                    v-else
                    height="372px"
                    class="mx-auto"
                    type="table-heading, table-thead, table-tbody, table-tfoot"
                  >
                  </v-skeleton-loader>
                </v-tab-item>
                <v-tab-item :key="2">
                  <v-card v-if="!overlay" flat class="py-3 px-3">
                    <v-card-title class="pt-0">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search Clients"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <newUser
                        @successAlert="successAlert"
                        :agencies="allAgencies"
                      />
                    </v-card-title>
                    <!-- {{ activeAcencies }} -->
                    <v-data-table
                      :headers="headers"
                      :items="agencySalesUsers"
                      :search="search"
                      :items-per-page="10"
                      :loading="overlay"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.isActive`]="{ item }">
                        <v-chip class="ma-2" color="success"> Active </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="viewUser(item)">
                              <v-list-item-content>
                                <v-list-item-title>
                                  View User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Deactivate User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-skeleton-loader
                    v-else
                    height="372px"
                    class="mx-auto"
                    type="table-heading, table-thead, table-tbody, table-tfoot"
                  >
                  </v-skeleton-loader>
                </v-tab-item>
                <v-tab-item :key="3">
                  <v-card v-if="!overlay" flat class="py-3 px-3">
                    <v-card-title class="pt-0">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search Clients"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <newUser
                        @successAlert="successAlert"
                        :agencies="allAgencies"
                      />
                    </v-card-title>
                    <!-- {{ activeAcencies }} -->
                    <v-data-table
                      :headers="headers"
                      :items="subscriberUsers"
                      :search="search"
                      :items-per-page="10"
                      :loading="overlay"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.isActive`]="{ item }">
                        <v-chip class="ma-2" color="success"> Active </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="viewUser(item)">
                              <v-list-item-content>
                                <v-list-item-title>
                                  View User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Deactivate User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-skeleton-loader
                    v-else
                    height="372px"
                    class="mx-auto"
                    type="table-heading, table-thead, table-tbody, table-tfoot"
                  >
                  </v-skeleton-loader>
                </v-tab-item>
                <v-tab-item :key="4">
                  <v-card v-if="!overlay" flat class="py-3 px-3">
                    <v-card-title class="pt-0">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search Clients"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <!-- {{ activeAcencies }} -->
                    <v-data-table
                      :headers="headers"
                      :items="inactiveUsers"
                      :search="search"
                      :items-per-page="10"
                      :loading="overlay"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.isActive`]="{ item }">
                        <v-chip
                          v-if="item.isActive == true"
                          class="ma-2"
                          color="success"
                        >
                          Active
                        </v-chip>
                        <v-chip v-else class="ma-2" color="error">
                          Inactive
                        </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="viewUser(item)">
                              <v-list-item-content>
                                <v-list-item-title>
                                  View User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-if="item.isActive == false"
                                >
                                  Activate User
                                </v-list-item-title>
                                <v-list-item-title v-else>
                                  Deactivate User
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-skeleton-loader
                    v-else
                    height="372px"
                    class="mx-auto"
                    type="table-heading, table-thead, table-tbody, table-tfoot"
                  >
                  </v-skeleton-loader>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import newUser from "@/components/dialogs/newUser.vue";
import generalAlert from "@/components/alerts/generalAlert.vue";
const moment = require("moment-timezone");

import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
export default {
  components: {
    newUser,
    generalAlert,
  },
  data: () => ({
    //Skeleton loading
    overlay: false,
    //Types of users
    superAdminUsers: [],
    agencyUsers: [],
    agencySalesUsers: [],
    subscriberUsers: [],
    inactiveUsers: [],
    //prop to pass through to page
    selectedUser: [],
    //prop for the add new user
    allAgencies: [],
    //For general alert on adding new user
    successResponse: "",
    alertType: "",
    alert: false,
    //Search field and data for table
    search: "",
    allActiveUsers: [],
    headers: [
      {
        text: "User Name",
        sortable: false,
        value: "name",
        align: "center",
      },
      {
        text: "Mobile",
        sortable: false,
        value: "mobile",
        align: "center",
      },
      {
        text: "Email Address",
        sortable: false,
        value: "email",
        align: "center",
      },
      {
        text: "Date Created",
        sortable: false,
        value: "dateRegistered",
        align: "center",
      },
      {
        text: "Status",
        sortable: false,
        value: "isActive",
        align: "center",
      },
      {
        text: "Action",
        sortable: false,
        value: "action",
        align: "center",
      },
    ],
    // tab varibles
    tab: null,

    //menu varibles
    // meunItems: [{ name: "View User" }],
  }),
  created() {
    this.overlay = true;
    if (this.$store.state.user.userType == "SA") {
      this.getAllCompeatUsers();
    } else {
      this.getAllAgencyUsers();
    }
  },
  methods: {
    //Gets all agency users and filters it out on userType
    async getAllAgencyUsers() {
      try {
        let superAdminUsers = [];
        let agencyUserss = [];
        let agencySalesUserss = [];
        let subscriberUserss = [];
        let inactiveUserss = [];

        const q = query(
          collection(db, "users"),
          where("agencyId", "==", this.$store.state.agency.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let user = doc.data();

          //format Date
          let createdMilliseconds = user.dateRegistered;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD");
          user.dateRegistered = formatCreatedDate;

          if (
            (user.isActive == true && user.userType == "AA") ||
            (user.isActive == true && user.userType == "SMM")
          ) {
            //Push item to array
            agencyUserss.push(user);
          } else if (user.isActive == true && user.userType == "SB") {
            // Format the date
            subscriberUserss.push(user);
          } else if (user.isActive == true && user.userType == "SA") {
            superAdminUsers.push(user);
          } else if (user.isActive == true && user.userType == "AS") {
            agencySalesUserss.push(user);
          } else if (user.isActive == false) {
            inactiveUserss.push(user);
          }
        });

        this.superAdminUsers = await this.sortUserArraysByDate(superAdminUsers);
        this.agencyUsers = await this.sortUserArraysByDate(agencyUserss);
        this.subscriberUsers = await this.sortUserArraysByDate(
          subscriberUserss
        );
        this.inactiveUsers = await this.sortUserArraysByDate(inactiveUserss);
        this.agencySalesUsers = await this.sortUserArraysByDate(
          agencySalesUserss
        );

        this.getAllAgencies();
      } catch (error) {
        console.log(error);
      }
    },
    //Gets all users
    async getAllCompeatUsers() {
      let superAdminUsers = [];
      let agencyUserss = [];
      let agencySalesUserss = [];
      let subscriberUserss = [];
      let inactiveUserss = [];
      const querySnapshot = await getDocs(collection(db, "users"));
      querySnapshot.forEach((doc) => {
        let user = doc.data();

        //format Date
        let createdMilliseconds = user.dateRegistered;
        let formatCreatedDate =
          moment(createdMilliseconds).format("YYYY-MM-DD");
        user.dateRegistered = formatCreatedDate;

        if (
          (user.isActive == true && user.userType == "AA") ||
          (user.isActive == true && user.userType == "SMM")
        ) {
          //Push item to array
          agencyUserss.push(user);
        } else if (user.isActive == true && user.userType == "SB") {
          // Format the date
          subscriberUserss.push(user);
        } else if (user.isActive == true && user.userType == "SA") {
          superAdminUsers.push(user);
        } else if (user.isActive == true && user.userType == "AS") {
          agencySalesUserss.push(user);
        } else if (user.isActive == false) {
          inactiveUserss.push(user);
        }
      });

      this.superAdminUsers = await this.sortUserArraysByDate(superAdminUsers);
      this.agencyUsers = await this.sortUserArraysByDate(agencyUserss);
      this.subscriberUsers = await this.sortUserArraysByDate(subscriberUserss);
      this.inactiveUsers = await this.sortUserArraysByDate(inactiveUserss);
      this.agencySalesUsers = await this.sortUserArraysByDate(
        agencySalesUserss
      );

      this.getAllAgencies();
    },
    //sort by date
    sortUserArraysByDate(array) {
      array.sort((a, b) => {
        return new Date(b.dateRegistered) - new Date(a.dateRegistered);
      });

      return array;
    },
    //Gets all agencies for when a Superadmin
    async getAllAgencies() {
      try {
        const querySnapshot = await getDocs(collection(db, "agencies"));
        querySnapshot.forEach((doc) => {
          this.allAgencies.push(doc.data());
        });
        this.overlay = false;
      } catch (error) {
        console.log(error);
      }
    },
    //Alert functions to display response from adding new user
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAllAgencyUsers();
        this.alert = false;
      }, 3000);
    },
    viewUser(item) {
      console.log(item);
      this.$router.push({
        name: "singleUserView",
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
